<!-- CHART -->
<div id="chart-area-container" class="chart-area-container mt-6">
  <div id="chart-area" style="height: 250px; width: 100%"></div>
</div>
